/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ProductServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增产品
     * @param productAddDTO productAddDTO
     * @return OK
     */
    createProduct(productAddDTO: ProductAddDTO): Promise<Product> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateProduct(_response);
        });
    }

    protected processCreateProduct(response: AxiosResponse): Promise<Product> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? Product.fromJS(resultData200) : new Product();
            return result200;
        }
        return Promise.resolve<Product>(<any>null);
    }

    /**
     * 修改产品信息
     * @param productTypeUpdateDTO productTypeUpdateDTO
     * @return OK
     */
    updateProduct(productTypeUpdateDTO: ProductUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productTypeUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateProduct(_response);
        });
    }

    protected processUpdateProduct(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 批量删除产品
     * @param productIds productIds
     * @return OK
     */
    deleteProducts(productIds: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteProducts(_response);
        });
    }

    protected processDeleteProducts(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 导出产品
     * @param productExportDTO productExportDTO
     * @return OK
     */
    exportProduct(productExportDTO: ProductExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productExportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProduct(_response);
        });
    }

    protected processExportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出产品模板
     * @param typeId (optional) 产品类型id
     * @return OK
     */
    exportProductTemplate(typeId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/export/template?";
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProductTemplate(_response);
        });
    }

    protected processExportProductTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入产品数据
     * @param file (optional) file
     * @param typeId (optional) 产品类型id
     * @return OK
     */
    importProducts(file: FileParameter | null | undefined, typeId: string | null | undefined): Promise<ProductExportResult> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/import?";
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportProducts(_response);
        });
    }

    protected processImportProducts(response: AxiosResponse): Promise<ProductExportResult> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductExportResult.fromJS(resultData200) : new ProductExportResult();
            return result200;
        }
        return Promise.resolve<ProductExportResult>(<any>null);
    }

    /**
     * 导入产品数据
     * @param file (optional) file
     * @param fixedEdition (optional) 是否定版
     * @param typeId (optional) 产品类型id
     * @return OK
     */
    importProductsAndCraft(file: FileParameter | null | undefined, fixedEdition: boolean | null | undefined, typeId: string | null | undefined): Promise<ProductAndCraftExportResult> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/importProAndCraft?";
        if (fixedEdition !== undefined)
            url_ += "fixedEdition=" + encodeURIComponent("" + fixedEdition) + "&"; 
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportProductsAndCraft(_response);
        });
    }

    protected processImportProductsAndCraft(response: AxiosResponse): Promise<ProductAndCraftExportResult> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductAndCraftExportResult.fromJS(resultData200) : new ProductAndCraftExportResult();
            return result200;
        }
        return Promise.resolve<ProductAndCraftExportResult>(<any>null);
    }

    /**
     * 查询产品列表（不分页）
     * @param typeId (optional) 产品类型id
     * @return OK
     */
    getProductList(typeId: string | null | undefined): Promise<ProductInfoBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/list?";
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductList(_response);
        });
    }

    protected processGetProductList(response: AxiosResponse): Promise<ProductInfoBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInfoBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductInfoBO[]>(<any>null);
    }

    /**
     * 获取有工艺版本定板的产品
     * @param typeId (optional) 产品类型id
     * @return OK
     */
    getFixedBoardList(typeId: string | null | undefined): Promise<ProductBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/list-FixedBoard?";
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFixedBoardList(_response);
        });
    }

    protected processGetFixedBoardList(response: AxiosResponse): Promise<ProductBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductBO[]>(<any>null);
    }

    /**
     * 根据产品类型获取所有产品
     * @param typeId (optional) 产品类型id
     * @return OK
     */
    getWithTypeIdList(typeId: string | null | undefined): Promise<ProductBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/list-WithTypeId?";
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWithTypeIdList(_response);
        });
    }

    protected processGetWithTypeIdList(response: AxiosResponse): Promise<ProductBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductBO[]>(<any>null);
    }

    /**
     * 获取所有产品
     * @return OK
     */
    getAllProductList(): Promise<ProductBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/listAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllProductList(_response);
        });
    }

    protected processGetAllProductList(response: AxiosResponse): Promise<ProductBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductBO[]>(<any>null);
    }

    /**
     * 获取所有产品和定版的工艺路径
     * @return OK
     */
    getAllFixedProductAndCraftProcess(): Promise<ProductAndCraftProcessVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/listAllProductAndFixedCraftProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllFixedProductAndCraftProcess(_response);
        });
    }

    protected processGetAllFixedProductAndCraftProcess(response: AxiosResponse): Promise<ProductAndCraftProcessVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductAndCraftProcessVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductAndCraftProcessVO[]>(<any>null);
    }

    /**
     * 根据产品类型和产品编号获取所有产品
     * @param codes (optional) 产品编号
     * @param typeId (optional) 产品类型id
     * @return OK
     */
    getByTypeIdAndCodesList(codes: string[] | null | undefined, typeId: string | null | undefined): Promise<ProductBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/listByTypeIdAndCodes?";
        if (codes !== undefined)
            codes && codes.forEach(item => { url_ += "codes=" + encodeURIComponent("" + item) + "&"; });
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetByTypeIdAndCodesList(_response);
        });
    }

    protected processGetByTypeIdAndCodesList(response: AxiosResponse): Promise<ProductBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductBO[]>(<any>null);
    }

    /**
     * 查询分页
     * @param current (optional) 当前页
     * @param productSearchDTO productSearchDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageProducts(current: number | null | undefined, productSearchDTO: ProductSearchDTO, size: number | null | undefined): Promise<IPageOfProductBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productSearchDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageProducts(_response);
        });
    }

    protected processGetPageProducts(response: AxiosResponse): Promise<IPageOfProductBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfProductBO.fromJS(resultData200) : new IPageOfProductBO();
            return result200;
        }
        return Promise.resolve<IPageOfProductBO>(<any>null);
    }

    /**
     * 获得产品类型下定版工序的产品
     * @param productTypeId productTypeId
     * @return OK
     */
    getProductPlanList(productTypeId: string): Promise<ProductInfoBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/plan?";
        if (productTypeId === undefined || productTypeId === null)
            throw new Error("The parameter 'productTypeId' must be defined and cannot be null.");
        else
            url_ += "productTypeId=" + encodeURIComponent("" + productTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductPlanList(_response);
        });
    }

    protected processGetProductPlanList(response: AxiosResponse): Promise<ProductInfoBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInfoBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductInfoBO[]>(<any>null);
    }

    /**
     * 查询产品信息
     * @param typeId (optional) 产品类型id
     * @return OK
     */
    getProductInfo(typeId: string | null | undefined): Promise<ProductInfoVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/productInfo?";
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductInfo(_response);
        });
    }

    protected processGetProductInfo(response: AxiosResponse): Promise<ProductInfoVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInfoVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductInfoVO[]>(<any>null);
    }

    /**
     * 查询产品信息
     * @param id id
     * @return OK
     */
    getProduct(id: string): Promise<ProductBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProduct(_response);
        });
    }

    protected processGetProduct(response: AxiosResponse): Promise<ProductBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductBO.fromJS(resultData200) : new ProductBO();
            return result200;
        }
        return Promise.resolve<ProductBO>(<any>null);
    }

    /**
     * 删除产品
     * @param id id
     * @return OK
     */
    deleteProduct(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteProduct(_response);
        });
    }

    protected processDeleteProduct(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ProductionCraftServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新建工艺版本
     * @param productionCraftAddDTO productionCraftAddDTO
     * @return OK
     */
    createProductionCraft(productionCraftAddDTO: ProductionCraftAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionCraftAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateProductionCraft(_response);
        });
    }

    protected processCreateProductionCraft(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 其他产品复制工艺版本
     * @param copyCraftDTO copyCraftDTO
     * @return OK
     */
    copyCraftToOtherProduct(copyCraftDTO: CopyCraftDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/copyCraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(copyCraftDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCopyCraftToOtherProduct(_response);
        });
    }

    protected processCopyCraftToOtherProduct(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 当前产品复制工艺版本
     * @param craftId craftId
     * @return OK
     */
    copy(craftId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/copyCraft/{craftId}";
        if (craftId === undefined || craftId === null)
            throw new Error("The parameter 'craftId' must be defined.");
        url_ = url_.replace("{craftId}", encodeURIComponent("" + craftId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCopy(_response);
        });
    }

    protected processCopy(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 按照工艺版本Ids查询工序列表
     * @param ids ids
     * @return OK
     */
    getProcessForProductionCraftIds(ids: string[]): Promise<ProductionCraftProcessBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/craftIds/get?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessForProductionCraftIds(_response);
        });
    }

    protected processGetProcessForProductionCraftIds(response: AxiosResponse): Promise<ProductionCraftProcessBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionCraftProcessBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionCraftProcessBO[]>(<any>null);
    }

    /**
     * 删除单个文件
     * @param fileId fileId
     * @return OK
     */
    deleteFile(fileId: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/delete-file/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 导出产品工艺流程
     * @param craftId craftId
     * @return OK
     */
    exportProductCraft(craftId: string): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/export/{craftId}";
        if (craftId === undefined || craftId === null)
            throw new Error("The parameter 'craftId' must be defined.");
        url_ = url_.replace("{craftId}", encodeURIComponent("" + craftId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProductCraft(_response);
        });
    }

    protected processExportProductCraft(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 按资源ID查询文件列表
     * @param resourceId resourceId
     * @return OK
     */
    getResourceFileList(resourceId: string): Promise<CraftFileDTO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/file-list?";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined and cannot be null.");
        else
            url_ += "resourceId=" + encodeURIComponent("" + resourceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetResourceFileList(_response);
        });
    }

    protected processGetResourceFileList(response: AxiosResponse): Promise<CraftFileDTO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CraftFileDTO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<CraftFileDTO[]>(<any>null);
    }

    /**
     * 定版工艺版本
     * @param id id
     * @return OK
     */
    fixedEditionForProductionCraft(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/fixedEdition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFixedEditionForProductionCraft(_response);
        });
    }

    protected processFixedEditionForProductionCraft(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查看工艺版本备注
     * @param craftId (optional) 工艺版本id
     * @return OK
     */
    getRemarkInfo(craftId: string | null | undefined): Promise<ProductCraftRemarkInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/get-remark/{craftId}";
        if (craftId !== null && craftId !== undefined)
        url_ = url_.replace("{craftId}", encodeURIComponent("" + craftId)); 
        else
            url_ = url_.replace("/{craftId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetRemarkInfo(_response);
        });
    }

    protected processGetRemarkInfo(response: AxiosResponse): Promise<ProductCraftRemarkInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductCraftRemarkInfoVO.fromJS(resultData200) : new ProductCraftRemarkInfoVO();
            return result200;
        }
        return Promise.resolve<ProductCraftRemarkInfoVO>(<any>null);
    }

    /**
     * 获取产品的工艺版本和备注
     * @param productId (optional) 产品Id
     * @return OK
     */
    getProductCraftRemark(productId: string | null | undefined): Promise<ProductionCraftBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/product-craft-remark?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductCraftRemark(_response);
        });
    }

    protected processGetProductCraftRemark(response: AxiosResponse): Promise<ProductionCraftBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionCraftBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionCraftBO[]>(<any>null);
    }

    /**
     * 按产品Ids查询工艺版本列表
     * @param ids ids
     * @return OK
     */
    getProductionCraftByProductIds(ids: string[]): Promise<ProductionCraftBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/productIds/get?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionCraftByProductIds(_response);
        });
    }

    protected processGetProductionCraftByProductIds(response: AxiosResponse): Promise<ProductionCraftBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionCraftBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionCraftBO[]>(<any>null);
    }

    /**
     * 保存工艺版本备注
     * @param saveRemarkDTO saveRemarkDTO
     * @return OK
     */
    saveCraftRemark(saveRemarkDTO: SaveRemarkDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/save-remark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveRemarkDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveCraftRemark(_response);
        });
    }

    protected processSaveCraftRemark(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 上传工艺文档
     * @param fileUploadDTO fileUploadDTO
     * @return OK
     */
    uploadFile(fileUploadDTO: FileUploadDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/upload-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileUploadDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 按照工艺版本查询工序列表
     * @param id id
     * @return OK
     */
    getProcessForProductionCraft(id: string): Promise<ProductionCraftProcessBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessForProductionCraft(_response);
        });
    }

    protected processGetProcessForProductionCraft(response: AxiosResponse): Promise<ProductionCraftProcessBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionCraftProcessBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionCraftProcessBO[]>(<any>null);
    }

    /**
     * 删除产品工艺版本
     * @param id id
     * @return OK
     */
    deleteProductionCraft(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteProductionCraft(_response);
        });
    }

    protected processDeleteProductionCraft(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 按产品查询工艺版本列表
     * @param productId productId
     * @return OK
     */
    getProductionCraftByProduct(productId: string): Promise<ProductionCraftBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/{productId}/crafts";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductionCraftByProduct(_response);
        });
    }

    protected processGetProductionCraftByProduct(response: AxiosResponse): Promise<ProductionCraftBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductionCraftBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductionCraftBO[]>(<any>null);
    }
}

export class ProductCraftExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 产品工艺工序的模板导出
     * @param typeId (optional) 产品类型id
     * @return OK
     */
    downloadTemple(typeId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/import/download-temple?";
        if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDownloadTemple(_response);
        });
    }

    protected processDownloadTemple(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 批量导入产品工艺工序
     * @param file (optional) 上传的文件
     * @param productId (optional) 产品Id
     * @return OK
     */
    importProductCraft(file: FileParameter | null | undefined, productId: Blob | null | undefined): Promise<ProductCraftImportResult> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-craft/import/import-excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportProductCraft(_response);
        });
    }

    protected processImportProductCraft(response: AxiosResponse): Promise<ProductCraftImportResult> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductCraftImportResult.fromJS(resultData200) : new ProductCraftImportResult();
            return result200;
        }
        return Promise.resolve<ProductCraftImportResult>(<any>null);
    }
}

export class ProductTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增产品类型
     * @param productTypeAddDTO productTypeAddDTO
     * @return OK
     */
    createProductType(productTypeAddDTO: ProductTypeAddDTO): Promise<ProductType> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productTypeAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateProductType(_response);
        });
    }

    protected processCreateProductType(response: AxiosResponse): Promise<ProductType> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductType.fromJS(resultData200) : new ProductType();
            return result200;
        }
        return Promise.resolve<ProductType>(<any>null);
    }

    /**
     * 修改产品类型
     * @param productTypeUpdateDTO productTypeUpdateDTO
     * @return OK
     */
    updateProductType(productTypeUpdateDTO: ProductTypeUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productTypeUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateProductType(_response);
        });
    }

    protected processUpdateProductType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 批量删除产品类型
     * @param deleteProductTypeDTO deleteProductTypeDTO
     * @return OK
     */
    deleteProductTypes(deleteProductTypeDTO: DeleteProductTypeDTO): Promise<DeleteProductTypeResult> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteProductTypeDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteProductTypes(_response);
        });
    }

    protected processDeleteProductTypes(response: AxiosResponse): Promise<DeleteProductTypeResult> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? DeleteProductTypeResult.fromJS(resultData200) : new DeleteProductTypeResult();
            return result200;
        }
        return Promise.resolve<DeleteProductTypeResult>(<any>null);
    }

    /**
     * 产品类型列表（不分页）
     * @return OK
     */
    getProductTypeList(): Promise<ProductTypeBO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-type/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductTypeList(_response);
        });
    }

    protected processGetProductTypeList(response: AxiosResponse): Promise<ProductTypeBO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductTypeBO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProductTypeBO[]>(<any>null);
    }

    /**
     * 产品类型分页列表
     * @param current (optional) 当前页
     * @param description (optional) 描述
     * @param name (optional) 产品类型名称
     * @param size (optional) 每页的数量
     * @param status (optional) 状态 2 - 开启；1 - 禁用
     * @return OK
     */
    getPageProductTypes(current: number | null | undefined, description: string | null | undefined, name: string | null | undefined, size: number | null | undefined, status: number | null | undefined): Promise<IPageOfProductTypeBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-type/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageProductTypes(_response);
        });
    }

    protected processGetPageProductTypes(response: AxiosResponse): Promise<IPageOfProductTypeBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfProductTypeBO.fromJS(resultData200) : new IPageOfProductTypeBO();
            return result200;
        }
        return Promise.resolve<IPageOfProductTypeBO>(<any>null);
    }

    /**
     * 更新产品类型状态
     * @param id 产品类型编号
     * @param status 状态。2 - 开启；1 - 禁用
     * @return OK
     */
    updateProductTypeStatus(id: string, status: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-type/status?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateProductTypeStatus(_response);
        });
    }

    protected processUpdateProductTypeStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取产品类型详情
     * @param id id
     * @return OK
     */
    getProductType(id: string): Promise<ProductTypeBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/product-type/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProductType(_response);
        });
    }

    protected processGetProductType(response: AxiosResponse): Promise<ProductTypeBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ProductTypeBO.fromJS(resultData200) : new ProductTypeBO();
            return result200;
        }
        return Promise.resolve<ProductTypeBO>(<any>null);
    }
}

export class ProductionCraftProcessServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 暂存工艺版本指定的工序配置
     * @param productionCraftProcessDTO productionCraftProcessDTO
     * @return OK
     */
    storageProcessForCraft(productionCraftProcessDTO: ProductionCraftProcessDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/production-craft-process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionCraftProcessDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStorageProcessForCraft(_response);
        });
    }

    protected processStorageProcessForCraft(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新未定版工艺版本的指定工序
     * @param productionCraftProcessUpdateDTO productionCraftProcessUpdateDTO
     * @return OK
     */
    updateProcessForCraft(productionCraftProcessUpdateDTO: ProductionCraftProcessUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/production-craft-process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionCraftProcessUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateProcessForCraft(_response);
        });
    }

    protected processUpdateProcessForCraft(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 批量删除工艺版本得工序
     * @param processIds processIds
     * @return OK
     */
    deleteProductionCraftProcess(processIds: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/production-craft-process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteProductionCraftProcess(_response);
        });
    }

    protected processDeleteProductionCraftProcess(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新定版工艺版本的指定工序信息
     * @param productionCraftProcessUpdateDTO productionCraftProcessUpdateDTO
     * @return OK
     */
    updateProcessForFixedCraft(productionCraftProcessUpdateDTO: ProductionFixedCraftProcessUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/production-craft-process/fixedCraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionCraftProcessUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateProcessForFixedCraft(_response);
        });
    }

    protected processUpdateProcessForFixedCraft(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 暂存工艺版本指定的工序配置
     * @param productionCraftProcessDTO productionCraftProcessDTO
     * @return OK
     */
    storageProcessForCraftForOpenApi(productionCraftProcessDTO: ProductionCraftProcessOpenApiDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/production-craft-process/open-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionCraftProcessDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStorageProcessForCraftForOpenApi(_response);
        });
    }

    protected processStorageProcessForCraftForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新未定版工艺版本的指定工序
     * @param productionCraftProcessUpdateDTO productionCraftProcessUpdateDTO
     * @return OK
     */
    updateProcessForCraftForOpenApi(productionCraftProcessUpdateDTO: ProductionCraftProcessUpdateOpenApiDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/production-craft-process/open-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productionCraftProcessUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateProcessForCraftForOpenApi(_response);
        });
    }

    protected processUpdateProcessForCraftForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * open-api批量删除工艺版本得工序
     * @param craftProcessIds craftProcessIds
     * @return OK
     */
    deleteProductionCraftProcessForOpenApi(craftProcessIds: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/production-craft-process/open-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(craftProcessIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteProductionCraftProcessForOpenApi(_response);
        });
    }

    protected processDeleteProductionCraftProcessForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 全量保存或编辑工艺版本的工序信息
     * @param saveOrUpdateCraftProcessDTO saveOrUpdateCraftProcessDTO
     * @return OK
     */
    saveOrUpdateCraftProcessForOpenApi(saveOrUpdateCraftProcessDTO: SaveOrUpdateCraftProcessApiDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/production-craft-process/open-api/saveOrUpdateCraftProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveOrUpdateCraftProcessDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveOrUpdateCraftProcessForOpenApi(_response);
        });
    }

    protected processSaveOrUpdateCraftProcessForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 批量保存或编辑工艺版本的工序信息
     * @param saveOrUpdateCraftProcessDTO saveOrUpdateCraftProcessDTO
     * @return OK
     */
    saveOrUpdateCraftProcess(saveOrUpdateCraftProcessDTO: SaveOrUpdateCraftProcessDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/production-craft-process/saveOrUpdateCraftProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saveOrUpdateCraftProcessDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveOrUpdateCraftProcess(_response);
        });
    }

    protected processSaveOrUpdateCraftProcess(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class QcItemServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增质检项
     * @param dto dto
     * @return OK
     */
    createQcItem(dto: QcItemDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateQcItem(_response);
        });
    }

    protected processCreateQcItem(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除质检项
     * @param qcProcessId (optional) qcProcessId
     * @return OK
     */
    deleteQcItem(qcProcessId: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-item?";
        if (qcProcessId !== undefined)
            url_ += "qcProcessId=" + encodeURIComponent("" + qcProcessId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteQcItem(_response);
        });
    }

    protected processDeleteQcItem(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据工艺id、质检工序编码和质检工序顺序查询质检项
     * @param craftId (optional) craftId
     * @param processCode (optional) processCode
     * @param processSort (optional) processSort
     * @return OK
     */
    getQcItemsByCraftId(craftId: string | null | undefined, processCode: string | null | undefined, processSort: string | null | undefined): Promise<QcItemVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-item/detail?";
        if (craftId !== undefined)
            url_ += "craftId=" + encodeURIComponent("" + craftId) + "&"; 
        if (processCode !== undefined)
            url_ += "processCode=" + encodeURIComponent("" + processCode) + "&"; 
        if (processSort !== undefined)
            url_ += "processSort=" + encodeURIComponent("" + processSort) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetQcItemsByCraftId(_response);
        });
    }

    protected processGetQcItemsByCraftId(response: AxiosResponse): Promise<QcItemVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QcItemVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<QcItemVO[]>(<any>null);
    }

    /**
     * 分页查询质检项
     * @param current (optional) 当前页
     * @param qcProcessId (optional) qcProcessId
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageQcItem(current: number | null | undefined, qcProcessId: string | null | undefined, size: number | null | undefined): Promise<IPageOfQcItemVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-item/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (qcProcessId !== undefined)
            url_ += "qcProcessId=" + encodeURIComponent("" + qcProcessId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageQcItem(_response);
        });
    }

    protected processGetPageQcItem(response: AxiosResponse): Promise<IPageOfQcItemVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfQcItemVO.fromJS(resultData200) : new IPageOfQcItemVO();
            return result200;
        }
        return Promise.resolve<IPageOfQcItemVO>(<any>null);
    }
}

export class QcProcessServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增或更新质检工序
     * @param dto dto
     * @return OK
     */
    createOrUpdateQcProcess(dto: QcProcessItemAddDTO[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateQcProcess(_response);
        });
    }

    protected processCreateOrUpdateQcProcess(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除质检工序
     * @param ids ids
     * @return OK
     */
    deleteQcProcess(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteQcProcess(_response);
        });
    }

    protected processDeleteQcProcess(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询工序编码
     * @param qcVersionId qcVersionId
     * @return OK
     */
    getQcProcessCode(qcVersionId: string): Promise<string[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-process/code?";
        if (qcVersionId === undefined || qcVersionId === null)
            throw new Error("The parameter 'qcVersionId' must be defined and cannot be null.");
        else
            url_ += "qcVersionId=" + encodeURIComponent("" + qcVersionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetQcProcessCode(_response);
        });
    }

    protected processGetQcProcessCode(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * 查询质检工序
     * @param qcProcessCode qcProcessCode
     * @param qcProcessSort qcProcessSort
     * @param qcVersionId qcVersionId
     * @return OK
     */
    getQcProcess(qcProcessCode: string, qcProcessSort: number, qcVersionId: string): Promise<QcProcessVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-process/detail?";
        if (qcProcessCode === undefined || qcProcessCode === null)
            throw new Error("The parameter 'qcProcessCode' must be defined and cannot be null.");
        else
            url_ += "qcProcessCode=" + encodeURIComponent("" + qcProcessCode) + "&"; 
        if (qcProcessSort === undefined || qcProcessSort === null)
            throw new Error("The parameter 'qcProcessSort' must be defined and cannot be null.");
        else
            url_ += "qcProcessSort=" + encodeURIComponent("" + qcProcessSort) + "&"; 
        if (qcVersionId === undefined || qcVersionId === null)
            throw new Error("The parameter 'qcVersionId' must be defined and cannot be null.");
        else
            url_ += "qcVersionId=" + encodeURIComponent("" + qcVersionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetQcProcess(_response);
        });
    }

    protected processGetQcProcess(response: AxiosResponse): Promise<QcProcessVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? QcProcessVO.fromJS(resultData200) : new QcProcessVO();
            return result200;
        }
        return Promise.resolve<QcProcessVO>(<any>null);
    }

    /**
     * 分页查询质检工序
     * @param current (optional) 当前页
     * @param qcVersionId qcVersionId
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageQcProcess(current: number | null | undefined, qcVersionId: string, size: number | null | undefined): Promise<IPageOfQcProcessVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-process/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (qcVersionId === undefined || qcVersionId === null)
            throw new Error("The parameter 'qcVersionId' must be defined and cannot be null.");
        else
            url_ += "qcVersionId=" + encodeURIComponent("" + qcVersionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageQcProcess(_response);
        });
    }

    protected processGetPageQcProcess(response: AxiosResponse): Promise<IPageOfQcProcessVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfQcProcessVO.fromJS(resultData200) : new IPageOfQcProcessVO();
            return result200;
        }
        return Promise.resolve<IPageOfQcProcessVO>(<any>null);
    }

    /**
     * 获取质检工序和质检项
     * @param qcVersionId qcVersionId
     * @return OK
     */
    getQcProcessAndItem(qcVersionId: string): Promise<QcProcessItemVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-process/processAndItem?";
        if (qcVersionId === undefined || qcVersionId === null)
            throw new Error("The parameter 'qcVersionId' must be defined and cannot be null.");
        else
            url_ += "qcVersionId=" + encodeURIComponent("" + qcVersionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetQcProcessAndItem(_response);
        });
    }

    protected processGetQcProcessAndItem(response: AxiosResponse): Promise<QcProcessItemVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QcProcessItemVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<QcProcessItemVO[]>(<any>null);
    }

    /**
     * 查询工序顺序
     * @param qcProcessCode qcProcessCode
     * @param qcVersionId qcVersionId
     * @return OK
     */
    getQcProcessSort(qcProcessCode: string, qcVersionId: string): Promise<number[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-process/sort?";
        if (qcProcessCode === undefined || qcProcessCode === null)
            throw new Error("The parameter 'qcProcessCode' must be defined and cannot be null.");
        else
            url_ += "qcProcessCode=" + encodeURIComponent("" + qcProcessCode) + "&"; 
        if (qcVersionId === undefined || qcVersionId === null)
            throw new Error("The parameter 'qcVersionId' must be defined and cannot be null.");
        else
            url_ += "qcVersionId=" + encodeURIComponent("" + qcVersionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetQcProcessSort(_response);
        });
    }

    protected processGetQcProcessSort(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return result200;
        }
        return Promise.resolve<number[]>(<any>null);
    }
}

export class QcVersionServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询质检版本
     * @param productId (optional) productId
     * @return OK
     */
    getPageQcVersion(productId: string | null | undefined): Promise<QcVersionVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-version?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageQcVersion(_response);
        });
    }

    protected processGetPageQcVersion(response: AxiosResponse): Promise<QcVersionVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QcVersionVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<QcVersionVO[]>(<any>null);
    }

    /**
     * 新增质检版本
     * @param dto dto
     * @return OK
     */
    createQcVersion(dto: QcVersionDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-version";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateQcVersion(_response);
        });
    }

    protected processCreateQcVersion(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 删除质检项
     * @param ids ids
     * @return OK
     */
    deleteQcVersion(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-version";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteQcVersion(_response);
        });
    }

    protected processDeleteQcVersion(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 复制质检版本
     * @param qcVersionCopyDTO qcVersionCopyDTO
     * @return OK
     */
    copyQcVersion(qcVersionCopyDTO: QcVersionCopyDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-version/duplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(qcVersionCopyDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCopyQcVersion(_response);
        });
    }

    protected processCopyQcVersion(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 获取产品下一次质检版本号
     * @param productId productId
     * @return OK
     */
    getNextVersion(productId: string): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/qc-version/nextVersion?";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetNextVersion(_response);
        });
    }

    protected processGetNextVersion(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-product')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class CopyCraftDTO implements ICopyCraftDTO {
    /** 工艺版本id */
    craftId!: string | undefined;
    /** 产品id */
    productId!: string | undefined;

    constructor(data?: ICopyCraftDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.productId = data["productId"];
        }
    }

    static fromJS(data: any): CopyCraftDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CopyCraftDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["productId"] = this.productId;
        return data; 
    }
}

export interface ICopyCraftDTO {
    /** 工艺版本id */
    craftId: string | undefined;
    /** 产品id */
    productId: string | undefined;
}

export class CraftFileDTO implements ICraftFileDTO {
    /** 文件ID */
    fileId!: string | undefined;
    /** 文件名称 */
    fileName!: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType!: number | undefined;

    constructor(data?: ICraftFileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
        }
    }

    static fromJS(data: any): CraftFileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CraftFileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        return data; 
    }
}

export interface ICraftFileDTO {
    /** 文件ID */
    fileId: string | undefined;
    /** 文件名称 */
    fileName: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType: number | undefined;
}

export class DeleteProductTypeDTO implements IDeleteProductTypeDTO {
    /** 是否强制删除 填：ture 或 false */
    force!: boolean;
    /** 产品类型ids */
    productTypeIds!: string[];

    constructor(data?: IDeleteProductTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productTypeIds = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.force = data["force"];
            if (data["productTypeIds"] && data["productTypeIds"].constructor === Array) {
                this.productTypeIds = [] as any;
                for (let item of data["productTypeIds"])
                    this.productTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteProductTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProductTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["force"] = this.force;
        if (this.productTypeIds && this.productTypeIds.constructor === Array) {
            data["productTypeIds"] = [];
            for (let item of this.productTypeIds)
                data["productTypeIds"].push(item);
        }
        return data; 
    }
}

export interface IDeleteProductTypeDTO {
    /** 是否强制删除 填：ture 或 false */
    force: boolean;
    /** 产品类型ids */
    productTypeIds: string[];
}

export class DeleteProductTypeResult implements IDeleteProductTypeResult {
    /** 返回删除信息 */
    message!: string | undefined;
    /** 产品类型ids */
    productTypeIds!: string[] | undefined;

    constructor(data?: IDeleteProductTypeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            if (data["productTypeIds"] && data["productTypeIds"].constructor === Array) {
                this.productTypeIds = [] as any;
                for (let item of data["productTypeIds"])
                    this.productTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteProductTypeResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProductTypeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (this.productTypeIds && this.productTypeIds.constructor === Array) {
            data["productTypeIds"] = [];
            for (let item of this.productTypeIds)
                data["productTypeIds"].push(item);
        }
        return data; 
    }
}

export interface IDeleteProductTypeResult {
    /** 返回删除信息 */
    message: string | undefined;
    /** 产品类型ids */
    productTypeIds: string[] | undefined;
}

export class FileUploadDTO implements IFileUploadDTO {
    /** 工艺版本ID */
    craftIds!: string[] | undefined;
    /** 文件信息列表 */
    fileList!: SaveFileInfoVO[] | undefined;

    constructor(data?: IFileUploadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["craftIds"] && data["craftIds"].constructor === Array) {
                this.craftIds = [] as any;
                for (let item of data["craftIds"])
                    this.craftIds!.push(item);
            }
            if (data["fileList"] && data["fileList"].constructor === Array) {
                this.fileList = [] as any;
                for (let item of data["fileList"])
                    this.fileList!.push(SaveFileInfoVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileUploadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.craftIds && this.craftIds.constructor === Array) {
            data["craftIds"] = [];
            for (let item of this.craftIds)
                data["craftIds"].push(item);
        }
        if (this.fileList && this.fileList.constructor === Array) {
            data["fileList"] = [];
            for (let item of this.fileList)
                data["fileList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFileUploadDTO {
    /** 工艺版本ID */
    craftIds: string[] | undefined;
    /** 文件信息列表 */
    fileList: SaveFileInfoVO[] | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class IPageOfProductBO implements IIPageOfProductBO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ProductBO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfProductBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ProductBO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfProductBO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfProductBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfProductBO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ProductBO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfProductTypeBO implements IIPageOfProductTypeBO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ProductTypeBO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfProductTypeBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ProductTypeBO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfProductTypeBO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfProductTypeBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfProductTypeBO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ProductTypeBO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfQcItemVO implements IIPageOfQcItemVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: QcItemVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfQcItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(QcItemVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfQcItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfQcItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfQcItemVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: QcItemVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfQcProcessVO implements IIPageOfQcProcessVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: QcProcessVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfQcProcessVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(QcProcessVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfQcProcessVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfQcProcessVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfQcProcessVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: QcProcessVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

/** 产品信息 */
export class Product implements IProduct {
    attachment!: string | undefined;
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    cutterCode!: string | undefined;
    description!: string | undefined;
    extend1!: string | undefined;
    extend2!: string | undefined;
    extend3!: string | undefined;
    extend4!: string | undefined;
    extend5!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    materialCode!: string | undefined;
    moldCode!: string | undefined;
    name!: string | undefined;
    replaceCodes!: string | undefined;
    replaceSupplier!: string | undefined;
    standardModel!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    stuff!: string | undefined;
    stuffStatus!: string | undefined;
    supplier!: string | undefined;
    tenantId!: string | undefined;
    typeId!: string | undefined;
    unit!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attachment = data["attachment"];
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.cutterCode = data["cutterCode"];
            this.description = data["description"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.materialCode = data["materialCode"];
            this.moldCode = data["moldCode"];
            this.name = data["name"];
            this.replaceCodes = data["replaceCodes"];
            this.replaceSupplier = data["replaceSupplier"];
            this.standardModel = data["standardModel"];
            this.status = data["status"];
            this.stuff = data["stuff"];
            this.stuffStatus = data["stuffStatus"];
            this.supplier = data["supplier"];
            this.tenantId = data["tenantId"];
            this.typeId = data["typeId"];
            this.unit = data["unit"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment;
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["cutterCode"] = this.cutterCode;
        data["description"] = this.description;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["materialCode"] = this.materialCode;
        data["moldCode"] = this.moldCode;
        data["name"] = this.name;
        data["replaceCodes"] = this.replaceCodes;
        data["replaceSupplier"] = this.replaceSupplier;
        data["standardModel"] = this.standardModel;
        data["status"] = this.status;
        data["stuff"] = this.stuff;
        data["stuffStatus"] = this.stuffStatus;
        data["supplier"] = this.supplier;
        data["tenantId"] = this.tenantId;
        data["typeId"] = this.typeId;
        data["unit"] = this.unit;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** 产品信息 */
export interface IProduct {
    attachment: string | undefined;
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    cutterCode: string | undefined;
    description: string | undefined;
    extend1: string | undefined;
    extend2: string | undefined;
    extend3: string | undefined;
    extend4: string | undefined;
    extend5: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    materialCode: string | undefined;
    moldCode: string | undefined;
    name: string | undefined;
    replaceCodes: string | undefined;
    replaceSupplier: string | undefined;
    standardModel: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    stuff: string | undefined;
    stuffStatus: string | undefined;
    supplier: string | undefined;
    tenantId: string | undefined;
    typeId: string | undefined;
    unit: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class ProductAddDTO implements IProductAddDTO {
    /** 产品编码 */
    code!: string;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 刀具编号 */
    cutterCode!: string | undefined;
    /** 产品描述 */
    description!: string | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 夹具编号 */
    moldCode!: string | undefined;
    /** 产品名称 */
    name!: string;
    /** 替代物料编号 */
    replaceCodes!: string | undefined;
    /** 替代材料供应商 */
    replaceSupplier!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 材料材质 */
    stuff!: string | undefined;
    /** 材料状态 */
    stuffStatus!: string | undefined;
    /** 原材料供应商 */
    supplier!: string | undefined;
    /** 所属产品类型 */
    typeId!: string;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IProductAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.cutterCode = data["cutterCode"];
            this.description = data["description"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.materialCode = data["materialCode"];
            this.moldCode = data["moldCode"];
            this.name = data["name"];
            this.replaceCodes = data["replaceCodes"];
            this.replaceSupplier = data["replaceSupplier"];
            this.standardModel = data["standardModel"];
            this.stuff = data["stuff"];
            this.stuffStatus = data["stuffStatus"];
            this.supplier = data["supplier"];
            this.typeId = data["typeId"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): ProductAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["cutterCode"] = this.cutterCode;
        data["description"] = this.description;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["materialCode"] = this.materialCode;
        data["moldCode"] = this.moldCode;
        data["name"] = this.name;
        data["replaceCodes"] = this.replaceCodes;
        data["replaceSupplier"] = this.replaceSupplier;
        data["standardModel"] = this.standardModel;
        data["stuff"] = this.stuff;
        data["stuffStatus"] = this.stuffStatus;
        data["supplier"] = this.supplier;
        data["typeId"] = this.typeId;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IProductAddDTO {
    /** 产品编码 */
    code: string;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 刀具编号 */
    cutterCode: string | undefined;
    /** 产品描述 */
    description: string | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 夹具编号 */
    moldCode: string | undefined;
    /** 产品名称 */
    name: string;
    /** 替代物料编号 */
    replaceCodes: string | undefined;
    /** 替代材料供应商 */
    replaceSupplier: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 材料材质 */
    stuff: string | undefined;
    /** 材料状态 */
    stuffStatus: string | undefined;
    /** 原材料供应商 */
    supplier: string | undefined;
    /** 所属产品类型 */
    typeId: string;
    /** 计量单位 */
    unit: string | undefined;
}

export class ProductAndCraftExportResult implements IProductAndCraftExportResult {
    productCraftImportResultList!: ProductCraftImportResult[] | undefined;
    productExportResult!: ProductExportResult | undefined;

    constructor(data?: IProductAndCraftExportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["productCraftImportResultList"] && data["productCraftImportResultList"].constructor === Array) {
                this.productCraftImportResultList = [] as any;
                for (let item of data["productCraftImportResultList"])
                    this.productCraftImportResultList!.push(ProductCraftImportResult.fromJS(item));
            }
            this.productExportResult = data["productExportResult"] ? ProductExportResult.fromJS(data["productExportResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductAndCraftExportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAndCraftExportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.productCraftImportResultList && this.productCraftImportResultList.constructor === Array) {
            data["productCraftImportResultList"] = [];
            for (let item of this.productCraftImportResultList)
                data["productCraftImportResultList"].push(item.toJSON());
        }
        data["productExportResult"] = this.productExportResult ? this.productExportResult.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IProductAndCraftExportResult {
    productCraftImportResultList: ProductCraftImportResult[] | undefined;
    productExportResult: ProductExportResult | undefined;
}

export class ProductAndCraftProcessVO implements IProductAndCraftProcessVO {
    /** 产品编号 */
    code!: string | undefined;
    /** 产品ID */
    id!: string | undefined;
    /** 产品名称 */
    name!: string | undefined;
    /** 工艺版本Id */
    productCraftId!: string | undefined;
    /** 工艺路径信息 */
    productionCraftProcessVOList!: ProductionCraftProcessVO[] | undefined;
    /** 工艺版本号 */
    version!: string | undefined;

    constructor(data?: IProductAndCraftProcessVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.productCraftId = data["productCraftId"];
            if (data["productionCraftProcessVOList"] && data["productionCraftProcessVOList"].constructor === Array) {
                this.productionCraftProcessVOList = [] as any;
                for (let item of data["productionCraftProcessVOList"])
                    this.productionCraftProcessVOList!.push(ProductionCraftProcessVO.fromJS(item));
            }
            this.version = data["version"];
        }
    }

    static fromJS(data: any): ProductAndCraftProcessVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAndCraftProcessVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["productCraftId"] = this.productCraftId;
        if (this.productionCraftProcessVOList && this.productionCraftProcessVOList.constructor === Array) {
            data["productionCraftProcessVOList"] = [];
            for (let item of this.productionCraftProcessVOList)
                data["productionCraftProcessVOList"].push(item.toJSON());
        }
        data["version"] = this.version;
        return data; 
    }
}

export interface IProductAndCraftProcessVO {
    /** 产品编号 */
    code: string | undefined;
    /** 产品ID */
    id: string | undefined;
    /** 产品名称 */
    name: string | undefined;
    /** 工艺版本Id */
    productCraftId: string | undefined;
    /** 工艺路径信息 */
    productionCraftProcessVOList: ProductionCraftProcessVO[] | undefined;
    /** 工艺版本号 */
    version: string | undefined;
}

export class ProductBO implements IProductBO {
    /** 附件 */
    attachment!: string | undefined;
    /** 产品编码 */
    code!: string | undefined;
    /** 产品信息 */
    codeAndName!: string | undefined;
    /** 刀具编号 */
    cutterCode!: string | undefined;
    /** 产品描述 */
    description!: string | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 摸具编号 */
    moldCode!: string | undefined;
    /** 产品名称 */
    name!: string | undefined;
    /** 替代物料编号 */
    replaceCodes!: string | undefined;
    /** 替代材料供应商 */
    replaceSupplier!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 材料材质 */
    stuff!: string | undefined;
    /** 材料状态 */
    stuffStatus!: string | undefined;
    /** 原材料供应商 */
    supplier!: string | undefined;
    /** 所属产品类型 */
    typeId!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IProductBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attachment = data["attachment"];
            this.code = data["code"];
            this.codeAndName = data["codeAndName"];
            this.cutterCode = data["cutterCode"];
            this.description = data["description"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.moldCode = data["moldCode"];
            this.name = data["name"];
            this.replaceCodes = data["replaceCodes"];
            this.replaceSupplier = data["replaceSupplier"];
            this.standardModel = data["standardModel"];
            this.stuff = data["stuff"];
            this.stuffStatus = data["stuffStatus"];
            this.supplier = data["supplier"];
            this.typeId = data["typeId"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): ProductBO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment;
        data["code"] = this.code;
        data["codeAndName"] = this.codeAndName;
        data["cutterCode"] = this.cutterCode;
        data["description"] = this.description;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["moldCode"] = this.moldCode;
        data["name"] = this.name;
        data["replaceCodes"] = this.replaceCodes;
        data["replaceSupplier"] = this.replaceSupplier;
        data["standardModel"] = this.standardModel;
        data["stuff"] = this.stuff;
        data["stuffStatus"] = this.stuffStatus;
        data["supplier"] = this.supplier;
        data["typeId"] = this.typeId;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IProductBO {
    /** 附件 */
    attachment: string | undefined;
    /** 产品编码 */
    code: string | undefined;
    /** 产品信息 */
    codeAndName: string | undefined;
    /** 刀具编号 */
    cutterCode: string | undefined;
    /** 产品描述 */
    description: string | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 摸具编号 */
    moldCode: string | undefined;
    /** 产品名称 */
    name: string | undefined;
    /** 替代物料编号 */
    replaceCodes: string | undefined;
    /** 替代材料供应商 */
    replaceSupplier: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 材料材质 */
    stuff: string | undefined;
    /** 材料状态 */
    stuffStatus: string | undefined;
    /** 原材料供应商 */
    supplier: string | undefined;
    /** 所属产品类型 */
    typeId: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
}

export class ProductCraftImportResult implements IProductCraftImportResult {
    /** 失败原因 */
    failInfo!: string | undefined;
    /** 导入结果 */
    importResult!: string | undefined;

    constructor(data?: IProductCraftImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.failInfo = data["failInfo"];
            this.importResult = data["importResult"];
        }
    }

    static fromJS(data: any): ProductCraftImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCraftImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["failInfo"] = this.failInfo;
        data["importResult"] = this.importResult;
        return data; 
    }
}

export interface IProductCraftImportResult {
    /** 失败原因 */
    failInfo: string | undefined;
    /** 导入结果 */
    importResult: string | undefined;
}

export class ProductCraftProcessApiDTO implements IProductCraftProcessApiDTO {
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 所属生产工序 */
    processId!: string;
    /** 工序序号 */
    processSequence!: string;
    /** 程序名称 */
    programName!: string | undefined;
    /** 工序顺序 */
    sort!: number;
    /** 标准工时（秒） */
    standardTime!: number | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IProductCraftProcessApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.prepareTime = data["prepareTime"];
            this.processId = data["processId"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): ProductCraftProcessApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCraftProcessApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["prepareTime"] = this.prepareTime;
        data["processId"] = this.processId;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

export interface IProductCraftProcessApiDTO {
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 所属生产工序 */
    processId: string;
    /** 工序序号 */
    processSequence: string;
    /** 程序名称 */
    programName: string | undefined;
    /** 工序顺序 */
    sort: number;
    /** 标准工时（秒） */
    standardTime: number | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
}

export class ProductCraftProcessDTO implements IProductCraftProcessDTO {
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 文件id */
    fileId!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 所属生产工序 */
    processId!: string;
    /** 工序序号 */
    processSequence!: string;
    /** 程序名称 */
    programName!: string | undefined;
    /** 工序顺序 */
    sort!: number;
    /** 标准工时（秒） */
    standardTime!: number | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IProductCraftProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.fileId = data["fileId"];
            this.id = data["id"];
            this.prepareTime = data["prepareTime"];
            this.processId = data["processId"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): ProductCraftProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCraftProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["prepareTime"] = this.prepareTime;
        data["processId"] = this.processId;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

export interface IProductCraftProcessDTO {
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 文件id */
    fileId: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 所属生产工序 */
    processId: string;
    /** 工序序号 */
    processSequence: string;
    /** 程序名称 */
    programName: string | undefined;
    /** 工序顺序 */
    sort: number;
    /** 标准工时（秒） */
    standardTime: number | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
}

export class ProductCraftRemarkInfoVO implements IProductCraftRemarkInfoVO {
    /** 备注内容 */
    remark!: string | undefined;
    /** 工艺版本号 */
    version!: string | undefined;

    constructor(data?: IProductCraftRemarkInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.remark = data["remark"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): ProductCraftRemarkInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCraftRemarkInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remark"] = this.remark;
        data["version"] = this.version;
        return data; 
    }
}

export interface IProductCraftRemarkInfoVO {
    /** 备注内容 */
    remark: string | undefined;
    /** 工艺版本号 */
    version: string | undefined;
}

export class ProductExportDTO implements IProductExportDTO {
    /** 是否选中导出 */
    exportSelected!: boolean | undefined;
    /** 筛选条件 */
    searchCondition!: ProductSearchDTO | undefined;
    /** 选中记录id集合 */
    selectedRecords!: string[] | undefined;
    /** 产品类型ID */
    typeId!: string | undefined;

    constructor(data?: IProductExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.exportSelected = data["exportSelected"];
            this.searchCondition = data["searchCondition"] ? ProductSearchDTO.fromJS(data["searchCondition"]) : <any>undefined;
            if (data["selectedRecords"] && data["selectedRecords"].constructor === Array) {
                this.selectedRecords = [] as any;
                for (let item of data["selectedRecords"])
                    this.selectedRecords!.push(item);
            }
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): ProductExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportSelected"] = this.exportSelected;
        data["searchCondition"] = this.searchCondition ? this.searchCondition.toJSON() : <any>undefined;
        if (this.selectedRecords && this.selectedRecords.constructor === Array) {
            data["selectedRecords"] = [];
            for (let item of this.selectedRecords)
                data["selectedRecords"].push(item);
        }
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IProductExportDTO {
    /** 是否选中导出 */
    exportSelected: boolean | undefined;
    /** 筛选条件 */
    searchCondition: ProductSearchDTO | undefined;
    /** 选中记录id集合 */
    selectedRecords: string[] | undefined;
    /** 产品类型ID */
    typeId: string | undefined;
}

export class ProductExportResult implements IProductExportResult {
    /** 失败记录数 */
    failUploadRecords!: number | undefined;
    /** 成功上传记录数 */
    successUploadRecords!: number | undefined;
    /** 上传记录数 */
    uploadTotal!: number | undefined;

    constructor(data?: IProductExportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.failUploadRecords = data["failUploadRecords"];
            this.successUploadRecords = data["successUploadRecords"];
            this.uploadTotal = data["uploadTotal"];
        }
    }

    static fromJS(data: any): ProductExportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProductExportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["failUploadRecords"] = this.failUploadRecords;
        data["successUploadRecords"] = this.successUploadRecords;
        data["uploadTotal"] = this.uploadTotal;
        return data; 
    }
}

export interface IProductExportResult {
    /** 失败记录数 */
    failUploadRecords: number | undefined;
    /** 成功上传记录数 */
    successUploadRecords: number | undefined;
    /** 上传记录数 */
    uploadTotal: number | undefined;
}

export class ProductInfoBO implements IProductInfoBO {
    /** 产品编号 */
    code!: string | undefined;
    /** 产品id */
    id!: string | undefined;
    /** 产品名称 */
    name!: string | undefined;

    constructor(data?: IProductInfoBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ProductInfoBO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfoBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IProductInfoBO {
    /** 产品编号 */
    code: string | undefined;
    /** 产品id */
    id: string | undefined;
    /** 产品名称 */
    name: string | undefined;
}

export class ProductInfoVO implements IProductInfoVO {
    /** 产品编号 */
    code!: string | undefined;
    /** 产品信息 */
    info!: string | undefined;
    /** 产品名称 */
    name!: string | undefined;

    constructor(data?: IProductInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.info = data["info"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ProductInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["info"] = this.info;
        data["name"] = this.name;
        return data; 
    }
}

export interface IProductInfoVO {
    /** 产品编号 */
    code: string | undefined;
    /** 产品信息 */
    info: string | undefined;
    /** 产品名称 */
    name: string | undefined;
}

export class ProductSearchDTO implements IProductSearchDTO {
    /** 是否高级筛选 */
    filterPlus!: boolean;
    /** 关键字查询 */
    keyWords!: string | undefined;
    /** 查询条件字典 */
    param!: any;
    /** 产品类型ID */
    typeId!: string | undefined;

    constructor(data?: IProductSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filterPlus = data["filterPlus"];
            this.keyWords = data["keyWords"];
            this.param = data["param"];
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): ProductSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterPlus"] = this.filterPlus;
        data["keyWords"] = this.keyWords;
        data["param"] = this.param;
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IProductSearchDTO {
    /** 是否高级筛选 */
    filterPlus: boolean;
    /** 关键字查询 */
    keyWords: string | undefined;
    /** 查询条件字典 */
    param: any;
    /** 产品类型ID */
    typeId: string | undefined;
}

/** 产品类型信息 */
export class ProductType implements IProductType {
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    /** 描述 */
    description!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    /** 产品类型名称 */
    name!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IProductType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.description = data["description"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.name = data["name"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): ProductType {
        data = typeof data === 'object' ? data : {};
        let result = new ProductType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

/** 产品类型信息 */
export interface IProductType {
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    /** 描述 */
    description: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    /** 产品类型名称 */
    name: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class ProductTypeAddDTO implements IProductTypeAddDTO {
    /** 描述 */
    description!: string | undefined;
    /** 产品类型名称 */
    name!: string;

    constructor(data?: IProductTypeAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ProductTypeAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        return data; 
    }
}

export interface IProductTypeAddDTO {
    /** 描述 */
    description: string | undefined;
    /** 产品类型名称 */
    name: string;
}

export class ProductTypeBO implements IProductTypeBO {
    /** 描述 */
    description!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 产品类型名称 */
    name!: string | undefined;
    /** 业务状态：0-禁用，1-启用 */
    status!: number | undefined;

    constructor(data?: IProductTypeBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
            this.name = data["name"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): ProductTypeBO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IProductTypeBO {
    /** 描述 */
    description: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 产品类型名称 */
    name: string | undefined;
    /** 业务状态：0-禁用，1-启用 */
    status: number | undefined;
}

export class ProductTypeUpdateDTO implements IProductTypeUpdateDTO {
    /** 描述 */
    description!: string | undefined;
    /** 主键id */
    id!: string;
    /** 产品类型名称 */
    name!: string;
    /** 业务状态 */
    status!: number | undefined;

    constructor(data?: IProductTypeUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
            this.name = data["name"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): ProductTypeUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTypeUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IProductTypeUpdateDTO {
    /** 描述 */
    description: string | undefined;
    /** 主键id */
    id: string;
    /** 产品类型名称 */
    name: string;
    /** 业务状态 */
    status: number | undefined;
}

export class ProductUpdateDTO implements IProductUpdateDTO {
    /** 产品编码 */
    code!: string;
    /** 刀具编号 */
    cutterCode!: string | undefined;
    /** 产品描述 */
    description!: string | undefined;
    /** 扩展字段1 */
    extend1!: string | undefined;
    /** 扩展字段2 */
    extend2!: string | undefined;
    /** 扩展字段3 */
    extend3!: string | undefined;
    /** 扩展字段4 */
    extend4!: string | undefined;
    /** 扩展字段5 */
    extend5!: string | undefined;
    /** 主键id */
    id!: string;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 夹具编号 */
    moldCode!: string | undefined;
    /** 产品名称 */
    name!: string;
    /** 替代物料编号 */
    replaceCodes!: string | undefined;
    /** 替代材料供应商 */
    replaceSupplier!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 材料材质 */
    stuff!: string | undefined;
    /** 材料状态 */
    stuffStatus!: string | undefined;
    /** 原材料供应商 */
    supplier!: string | undefined;
    /** 所属产品类型 */
    typeId!: string;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IProductUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.cutterCode = data["cutterCode"];
            this.description = data["description"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.moldCode = data["moldCode"];
            this.name = data["name"];
            this.replaceCodes = data["replaceCodes"];
            this.replaceSupplier = data["replaceSupplier"];
            this.standardModel = data["standardModel"];
            this.stuff = data["stuff"];
            this.stuffStatus = data["stuffStatus"];
            this.supplier = data["supplier"];
            this.typeId = data["typeId"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): ProductUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["cutterCode"] = this.cutterCode;
        data["description"] = this.description;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["moldCode"] = this.moldCode;
        data["name"] = this.name;
        data["replaceCodes"] = this.replaceCodes;
        data["replaceSupplier"] = this.replaceSupplier;
        data["standardModel"] = this.standardModel;
        data["stuff"] = this.stuff;
        data["stuffStatus"] = this.stuffStatus;
        data["supplier"] = this.supplier;
        data["typeId"] = this.typeId;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IProductUpdateDTO {
    /** 产品编码 */
    code: string;
    /** 刀具编号 */
    cutterCode: string | undefined;
    /** 产品描述 */
    description: string | undefined;
    /** 扩展字段1 */
    extend1: string | undefined;
    /** 扩展字段2 */
    extend2: string | undefined;
    /** 扩展字段3 */
    extend3: string | undefined;
    /** 扩展字段4 */
    extend4: string | undefined;
    /** 扩展字段5 */
    extend5: string | undefined;
    /** 主键id */
    id: string;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 夹具编号 */
    moldCode: string | undefined;
    /** 产品名称 */
    name: string;
    /** 替代物料编号 */
    replaceCodes: string | undefined;
    /** 替代材料供应商 */
    replaceSupplier: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 材料材质 */
    stuff: string | undefined;
    /** 材料状态 */
    stuffStatus: string | undefined;
    /** 原材料供应商 */
    supplier: string | undefined;
    /** 所属产品类型 */
    typeId: string;
    /** 计量单位 */
    unit: string | undefined;
}

export class ProductionCraftAddDTO implements IProductionCraftAddDTO {
    /** 所属产品 */
    productId!: string;

    constructor(data?: IProductionCraftAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
        }
    }

    static fromJS(data: any): ProductionCraftAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionCraftAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        return data; 
    }
}

export interface IProductionCraftAddDTO {
    /** 所属产品 */
    productId: string;
}

export class ProductionCraftBO implements IProductionCraftBO {
    /** 版本状态（1-暂存，2-定稿） */
    editionStatus!: number | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 所属产品 */
    productId!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 资源ID */
    resourceId!: string | undefined;
    /** 工艺版本 */
    version!: string | undefined;

    constructor(data?: IProductionCraftBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.editionStatus = data["editionStatus"];
            this.id = data["id"];
            this.productId = data["productId"];
            this.remark = data["remark"];
            this.resourceId = data["resourceId"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): ProductionCraftBO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionCraftBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionStatus"] = this.editionStatus;
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["remark"] = this.remark;
        data["resourceId"] = this.resourceId;
        data["version"] = this.version;
        return data; 
    }
}

export interface IProductionCraftBO {
    /** 版本状态（1-暂存，2-定稿） */
    editionStatus: number | undefined;
    /** 主键id */
    id: string | undefined;
    /** 所属产品 */
    productId: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 资源ID */
    resourceId: string | undefined;
    /** 工艺版本 */
    version: string | undefined;
}

export class ProductionCraftProcessBO implements IProductionCraftProcessBO {
    /** 工序编号 */
    code!: string | undefined;
    /** 所属工艺 */
    craftId!: string | undefined;
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 文件ID */
    fileId!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 工序名称 */
    name!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 所属生产工序 */
    processId!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 标准工时（秒） */
    standardTime!: number | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IProductionCraftProcessBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.craftId = data["craftId"];
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.fileId = data["fileId"];
            this.id = data["id"];
            this.name = data["name"];
            this.prepareTime = data["prepareTime"];
            this.processId = data["processId"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): ProductionCraftProcessBO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionCraftProcessBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["craftId"] = this.craftId;
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["prepareTime"] = this.prepareTime;
        data["processId"] = this.processId;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

export interface IProductionCraftProcessBO {
    /** 工序编号 */
    code: string | undefined;
    /** 所属工艺 */
    craftId: string | undefined;
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 文件ID */
    fileId: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 工序名称 */
    name: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 所属生产工序 */
    processId: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 标准工时（秒） */
    standardTime: number | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
}

export class ProductionCraftProcessDTO implements IProductionCraftProcessDTO {
    /** 工艺ID */
    craftId!: string | undefined;
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 文件id */
    fileId!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 所属生产工序 */
    processId!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 标准工时（秒） */
    standardTime!: number | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IProductionCraftProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.fileId = data["fileId"];
            this.prepareTime = data["prepareTime"];
            this.processId = data["processId"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): ProductionCraftProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionCraftProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["fileId"] = this.fileId;
        data["prepareTime"] = this.prepareTime;
        data["processId"] = this.processId;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

export interface IProductionCraftProcessDTO {
    /** 工艺ID */
    craftId: string | undefined;
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 文件id */
    fileId: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 所属生产工序 */
    processId: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 标准工时（秒） */
    standardTime: number | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
}

export class ProductionCraftProcessOpenApiDTO implements IProductionCraftProcessOpenApiDTO {
    /** 工艺ID */
    craftId!: string;
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 所属生产工序 */
    processId!: string;
    /** 工序序号 */
    processSequence!: string;
    /** 程序名称 */
    programName!: string | undefined;
    /** 标准工时（秒） */
    standardTime!: number | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IProductionCraftProcessOpenApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.prepareTime = data["prepareTime"];
            this.processId = data["processId"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): ProductionCraftProcessOpenApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionCraftProcessOpenApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["prepareTime"] = this.prepareTime;
        data["processId"] = this.processId;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

export interface IProductionCraftProcessOpenApiDTO {
    /** 工艺ID */
    craftId: string;
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 所属生产工序 */
    processId: string;
    /** 工序序号 */
    processSequence: string;
    /** 程序名称 */
    programName: string | undefined;
    /** 标准工时（秒） */
    standardTime: number | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
}

export class ProductionCraftProcessUpdateDTO implements IProductionCraftProcessUpdateDTO {
    /** 工艺ID */
    craftId!: string | undefined;
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 文件id */
    fileId!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 所属生产工序 */
    processId!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 标准工时（秒） */
    standardTime!: number | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IProductionCraftProcessUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.fileId = data["fileId"];
            this.id = data["id"];
            this.prepareTime = data["prepareTime"];
            this.processId = data["processId"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): ProductionCraftProcessUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionCraftProcessUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["fileId"] = this.fileId;
        data["id"] = this.id;
        data["prepareTime"] = this.prepareTime;
        data["processId"] = this.processId;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

export interface IProductionCraftProcessUpdateDTO {
    /** 工艺ID */
    craftId: string | undefined;
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 文件id */
    fileId: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 所属生产工序 */
    processId: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 标准工时（秒） */
    standardTime: number | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
}

export class ProductionCraftProcessUpdateOpenApiDTO implements IProductionCraftProcessUpdateOpenApiDTO {
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 主键id */
    id!: string;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 所属生产工序 */
    processId!: string;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 标准工时（秒） */
    standardTime!: number | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IProductionCraftProcessUpdateOpenApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.prepareTime = data["prepareTime"];
            this.processId = data["processId"];
            this.processSequence = data["processSequence"];
            this.programName = data["programName"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): ProductionCraftProcessUpdateOpenApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionCraftProcessUpdateOpenApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["prepareTime"] = this.prepareTime;
        data["processId"] = this.processId;
        data["processSequence"] = this.processSequence;
        data["programName"] = this.programName;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

export interface IProductionCraftProcessUpdateOpenApiDTO {
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 主键id */
    id: string;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 所属生产工序 */
    processId: string;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 标准工时（秒） */
    standardTime: number | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
}

export class ProductionCraftProcessVO implements IProductionCraftProcessVO {
    /** 工艺ID */
    craftId!: string | undefined;
    /** 工艺路径ID */
    id!: string | undefined;
    /** 所属生产工序 */
    processId!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工序顺序 */
    sort!: number | undefined;
    /** 标准工时（秒） */
    standardTime!: number | undefined;

    constructor(data?: IProductionCraftProcessVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.id = data["id"];
            this.processId = data["processId"];
            this.processSequence = data["processSequence"];
            this.sort = data["sort"];
            this.standardTime = data["standardTime"];
        }
    }

    static fromJS(data: any): ProductionCraftProcessVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionCraftProcessVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["id"] = this.id;
        data["processId"] = this.processId;
        data["processSequence"] = this.processSequence;
        data["sort"] = this.sort;
        data["standardTime"] = this.standardTime;
        return data; 
    }
}

export interface IProductionCraftProcessVO {
    /** 工艺ID */
    craftId: string | undefined;
    /** 工艺路径ID */
    id: string | undefined;
    /** 所属生产工序 */
    processId: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工序顺序 */
    sort: number | undefined;
    /** 标准工时（秒） */
    standardTime: number | undefined;
}

export class ProductionFixedCraftProcessUpdateDTO implements IProductionFixedCraftProcessUpdateDTO {
    /** 拆卸工时 */
    disassemblyTime!: number | undefined;
    /** 工艺参数1 */
    extend1!: string | undefined;
    /** 工艺参数2 */
    extend2!: string | undefined;
    /** 工艺参数3 */
    extend3!: string | undefined;
    /** 工艺参数4 */
    extend4!: string | undefined;
    /** 工艺参数5 */
    extend5!: string | undefined;
    /** 主键id */
    id!: string;
    /** 准备工时 */
    prepareTime!: number | undefined;
    /** 程序名称 */
    programName!: string | undefined;
    /** 标准工时（秒） */
    standardTime!: number | undefined;
    /** 运输工时 */
    transportTime!: number | undefined;

    constructor(data?: IProductionFixedCraftProcessUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.disassemblyTime = data["disassemblyTime"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.prepareTime = data["prepareTime"];
            this.programName = data["programName"];
            this.standardTime = data["standardTime"];
            this.transportTime = data["transportTime"];
        }
    }

    static fromJS(data: any): ProductionFixedCraftProcessUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionFixedCraftProcessUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disassemblyTime"] = this.disassemblyTime;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["prepareTime"] = this.prepareTime;
        data["programName"] = this.programName;
        data["standardTime"] = this.standardTime;
        data["transportTime"] = this.transportTime;
        return data; 
    }
}

export interface IProductionFixedCraftProcessUpdateDTO {
    /** 拆卸工时 */
    disassemblyTime: number | undefined;
    /** 工艺参数1 */
    extend1: string | undefined;
    /** 工艺参数2 */
    extend2: string | undefined;
    /** 工艺参数3 */
    extend3: string | undefined;
    /** 工艺参数4 */
    extend4: string | undefined;
    /** 工艺参数5 */
    extend5: string | undefined;
    /** 主键id */
    id: string;
    /** 准备工时 */
    prepareTime: number | undefined;
    /** 程序名称 */
    programName: string | undefined;
    /** 标准工时（秒） */
    standardTime: number | undefined;
    /** 运输工时 */
    transportTime: number | undefined;
}

export class QcItemDTO implements IQcItemDTO {
    /** 质检项名称 */
    name!: string;
    qcProcessId!: string | undefined;
    /** 标准数值 */
    standardValue!: string;

    constructor(data?: IQcItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.qcProcessId = data["qcProcessId"];
            this.standardValue = data["standardValue"];
        }
    }

    static fromJS(data: any): QcItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QcItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["qcProcessId"] = this.qcProcessId;
        data["standardValue"] = this.standardValue;
        return data; 
    }
}

export interface IQcItemDTO {
    /** 质检项名称 */
    name: string;
    qcProcessId: string | undefined;
    /** 标准数值 */
    standardValue: string;
}

export class QcItemVO implements IQcItemVO {
    /** 质检项名称 */
    name!: string | undefined;
    /** 工序id */
    qcProcessId!: string | undefined;
    /** 标准数值 */
    standardValue!: string | undefined;

    constructor(data?: IQcItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.qcProcessId = data["qcProcessId"];
            this.standardValue = data["standardValue"];
        }
    }

    static fromJS(data: any): QcItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new QcItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["qcProcessId"] = this.qcProcessId;
        data["standardValue"] = this.standardValue;
        return data; 
    }
}

export interface IQcItemVO {
    /** 质检项名称 */
    name: string | undefined;
    /** 工序id */
    qcProcessId: string | undefined;
    /** 标准数值 */
    standardValue: string | undefined;
}

export class QcProcessCopyVO implements IQcProcessCopyVO {
    /** 工序编号 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工序顺序 */
    processSort!: number | undefined;

    constructor(data?: IQcProcessCopyVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.processSort = data["processSort"];
        }
    }

    static fromJS(data: any): QcProcessCopyVO {
        data = typeof data === 'object' ? data : {};
        let result = new QcProcessCopyVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["processSort"] = this.processSort;
        return data; 
    }
}

export interface IQcProcessCopyVO {
    /** 工序编号 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工序顺序 */
    processSort: number | undefined;
}

export class QcProcessDTO implements IQcProcessDTO {
    /** 质检工序ID */
    id!: string;
    /** 工序编码 */
    processCode!: string;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string;
    /** 工序顺序 */
    processSort!: number;

    constructor(data?: IQcProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.processSort = data["processSort"];
        }
    }

    static fromJS(data: any): QcProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QcProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["processSort"] = this.processSort;
        return data; 
    }
}

export interface IQcProcessDTO {
    /** 质检工序ID */
    id: string;
    /** 工序编码 */
    processCode: string;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string;
    /** 工序顺序 */
    processSort: number;
}

export class QcProcessItemAddDTO implements IQcProcessItemAddDTO {
    qcItemDTOList!: QcItemDTO[] | undefined;
    qcProcessDTO!: QcProcessDTO | undefined;
    /** 质检工序版本ID */
    qcVersionId!: string;

    constructor(data?: IQcProcessItemAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["qcItemDTOList"] && data["qcItemDTOList"].constructor === Array) {
                this.qcItemDTOList = [] as any;
                for (let item of data["qcItemDTOList"])
                    this.qcItemDTOList!.push(QcItemDTO.fromJS(item));
            }
            this.qcProcessDTO = data["qcProcessDTO"] ? QcProcessDTO.fromJS(data["qcProcessDTO"]) : <any>undefined;
            this.qcVersionId = data["qcVersionId"];
        }
    }

    static fromJS(data: any): QcProcessItemAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QcProcessItemAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.qcItemDTOList && this.qcItemDTOList.constructor === Array) {
            data["qcItemDTOList"] = [];
            for (let item of this.qcItemDTOList)
                data["qcItemDTOList"].push(item.toJSON());
        }
        data["qcProcessDTO"] = this.qcProcessDTO ? this.qcProcessDTO.toJSON() : <any>undefined;
        data["qcVersionId"] = this.qcVersionId;
        return data; 
    }
}

export interface IQcProcessItemAddDTO {
    qcItemDTOList: QcItemDTO[] | undefined;
    qcProcessDTO: QcProcessDTO | undefined;
    /** 质检工序版本ID */
    qcVersionId: string;
}

export class QcProcessItemCopyDTO implements IQcProcessItemCopyDTO {
    qcItemVOList!: QcItemVO[] | undefined;
    qcProcessCopyVO!: QcProcessCopyVO | undefined;
    /** 质检工序版本ID */
    qcVersionId!: string;

    constructor(data?: IQcProcessItemCopyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["qcItemVOList"] && data["qcItemVOList"].constructor === Array) {
                this.qcItemVOList = [] as any;
                for (let item of data["qcItemVOList"])
                    this.qcItemVOList!.push(QcItemVO.fromJS(item));
            }
            this.qcProcessCopyVO = data["qcProcessCopyVO"] ? QcProcessCopyVO.fromJS(data["qcProcessCopyVO"]) : <any>undefined;
            this.qcVersionId = data["qcVersionId"];
        }
    }

    static fromJS(data: any): QcProcessItemCopyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QcProcessItemCopyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.qcItemVOList && this.qcItemVOList.constructor === Array) {
            data["qcItemVOList"] = [];
            for (let item of this.qcItemVOList)
                data["qcItemVOList"].push(item.toJSON());
        }
        data["qcProcessCopyVO"] = this.qcProcessCopyVO ? this.qcProcessCopyVO.toJSON() : <any>undefined;
        data["qcVersionId"] = this.qcVersionId;
        return data; 
    }
}

export interface IQcProcessItemCopyDTO {
    qcItemVOList: QcItemVO[] | undefined;
    qcProcessCopyVO: QcProcessCopyVO | undefined;
    /** 质检工序版本ID */
    qcVersionId: string;
}

export class QcProcessItemVO implements IQcProcessItemVO {
    qcItemVOList!: QcItemVO[] | undefined;
    qcProcessCopyVO!: QcProcessCopyVO | undefined;

    constructor(data?: IQcProcessItemVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["qcItemVOList"] && data["qcItemVOList"].constructor === Array) {
                this.qcItemVOList = [] as any;
                for (let item of data["qcItemVOList"])
                    this.qcItemVOList!.push(QcItemVO.fromJS(item));
            }
            this.qcProcessCopyVO = data["qcProcessCopyVO"] ? QcProcessCopyVO.fromJS(data["qcProcessCopyVO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QcProcessItemVO {
        data = typeof data === 'object' ? data : {};
        let result = new QcProcessItemVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.qcItemVOList && this.qcItemVOList.constructor === Array) {
            data["qcItemVOList"] = [];
            for (let item of this.qcItemVOList)
                data["qcItemVOList"].push(item.toJSON());
        }
        data["qcProcessCopyVO"] = this.qcProcessCopyVO ? this.qcProcessCopyVO.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IQcProcessItemVO {
    qcItemVOList: QcItemVO[] | undefined;
    qcProcessCopyVO: QcProcessCopyVO | undefined;
}

export class QcProcessVO implements IQcProcessVO {
    /** 工序id */
    id!: string | undefined;
    /** 工序编号 */
    processCode!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 工序序号 */
    processSequence!: string | undefined;
    /** 工序顺序 */
    processSort!: number | undefined;

    constructor(data?: IQcProcessVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.processCode = data["processCode"];
            this.processName = data["processName"];
            this.processSequence = data["processSequence"];
            this.processSort = data["processSort"];
        }
    }

    static fromJS(data: any): QcProcessVO {
        data = typeof data === 'object' ? data : {};
        let result = new QcProcessVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processCode"] = this.processCode;
        data["processName"] = this.processName;
        data["processSequence"] = this.processSequence;
        data["processSort"] = this.processSort;
        return data; 
    }
}

export interface IQcProcessVO {
    /** 工序id */
    id: string | undefined;
    /** 工序编号 */
    processCode: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 工序序号 */
    processSequence: string | undefined;
    /** 工序顺序 */
    processSort: number | undefined;
}

export class QcVersionCopyDTO implements IQcVersionCopyDTO {
    qcProcessItemCopyDTOList!: QcProcessItemCopyDTO[] | undefined;
    qcVersionDTO!: QcVersionDTO | undefined;

    constructor(data?: IQcVersionCopyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["qcProcessItemCopyDTOList"] && data["qcProcessItemCopyDTOList"].constructor === Array) {
                this.qcProcessItemCopyDTOList = [] as any;
                for (let item of data["qcProcessItemCopyDTOList"])
                    this.qcProcessItemCopyDTOList!.push(QcProcessItemCopyDTO.fromJS(item));
            }
            this.qcVersionDTO = data["qcVersionDTO"] ? QcVersionDTO.fromJS(data["qcVersionDTO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QcVersionCopyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QcVersionCopyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.qcProcessItemCopyDTOList && this.qcProcessItemCopyDTOList.constructor === Array) {
            data["qcProcessItemCopyDTOList"] = [];
            for (let item of this.qcProcessItemCopyDTOList)
                data["qcProcessItemCopyDTOList"].push(item.toJSON());
        }
        data["qcVersionDTO"] = this.qcVersionDTO ? this.qcVersionDTO.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IQcVersionCopyDTO {
    qcProcessItemCopyDTOList: QcProcessItemCopyDTO[] | undefined;
    qcVersionDTO: QcVersionDTO | undefined;
}

export class QcVersionDTO implements IQcVersionDTO {
    /** 工艺版本Id */
    craftId!: string;
    /** 工艺版本 */
    craftVersion!: string;
    /** 所属产品 */
    productId!: string;

    constructor(data?: IQcVersionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.craftVersion = data["craftVersion"];
            this.productId = data["productId"];
        }
    }

    static fromJS(data: any): QcVersionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QcVersionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["craftVersion"] = this.craftVersion;
        data["productId"] = this.productId;
        return data; 
    }
}

export interface IQcVersionDTO {
    /** 工艺版本Id */
    craftId: string;
    /** 工艺版本 */
    craftVersion: string;
    /** 所属产品 */
    productId: string;
}

export class QcVersionVO implements IQcVersionVO {
    /** 工艺版本id */
    craftId!: string | undefined;
    /** 质检版本id */
    id!: string | undefined;
    /** 质检版本 */
    version!: string | undefined;

    constructor(data?: IQcVersionVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.id = data["id"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): QcVersionVO {
        data = typeof data === 'object' ? data : {};
        let result = new QcVersionVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["id"] = this.id;
        data["version"] = this.version;
        return data; 
    }
}

export interface IQcVersionVO {
    /** 工艺版本id */
    craftId: string | undefined;
    /** 质检版本id */
    id: string | undefined;
    /** 质检版本 */
    version: string | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class SaveFileInfoVO implements ISaveFileInfoVO {
    /** 文件大小,必须大于等于0 */
    contentLength!: string | undefined;
    /** 文件H5 */
    contentMd5!: string | undefined;
    /** 内容类型，文件夹为null */
    contentType!: string | undefined;
    /** 名称 */
    displayName!: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType!: number | undefined;
    /** 文件唯一标识 */
    objectKey!: string | undefined;
    /** 后缀名，文件夹为null */
    suffix!: string | undefined;

    constructor(data?: ISaveFileInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentLength = data["contentLength"];
            this.contentMd5 = data["contentMd5"];
            this.contentType = data["contentType"];
            this.displayName = data["displayName"];
            this.fileType = data["fileType"];
            this.objectKey = data["objectKey"];
            this.suffix = data["suffix"];
        }
    }

    static fromJS(data: any): SaveFileInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFileInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentLength"] = this.contentLength;
        data["contentMd5"] = this.contentMd5;
        data["contentType"] = this.contentType;
        data["displayName"] = this.displayName;
        data["fileType"] = this.fileType;
        data["objectKey"] = this.objectKey;
        data["suffix"] = this.suffix;
        return data; 
    }
}

export interface ISaveFileInfoVO {
    /** 文件大小,必须大于等于0 */
    contentLength: string | undefined;
    /** 文件H5 */
    contentMd5: string | undefined;
    /** 内容类型，文件夹为null */
    contentType: string | undefined;
    /** 名称 */
    displayName: string | undefined;
    /** 文件类别：1、加工文件，2、工艺文件 */
    fileType: number | undefined;
    /** 文件唯一标识 */
    objectKey: string | undefined;
    /** 后缀名，文件夹为null */
    suffix: string | undefined;
}

export class SaveOrUpdateCraftProcessApiDTO implements ISaveOrUpdateCraftProcessApiDTO {
    /** 工艺ID */
    craftId!: string;
    /** 工艺版本工序列表 */
    productCraftProcessDTOList!: ProductCraftProcessApiDTO[] | undefined;

    constructor(data?: ISaveOrUpdateCraftProcessApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            if (data["productCraftProcessDTOList"] && data["productCraftProcessDTOList"].constructor === Array) {
                this.productCraftProcessDTOList = [] as any;
                for (let item of data["productCraftProcessDTOList"])
                    this.productCraftProcessDTOList!.push(ProductCraftProcessApiDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveOrUpdateCraftProcessApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveOrUpdateCraftProcessApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        if (this.productCraftProcessDTOList && this.productCraftProcessDTOList.constructor === Array) {
            data["productCraftProcessDTOList"] = [];
            for (let item of this.productCraftProcessDTOList)
                data["productCraftProcessDTOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISaveOrUpdateCraftProcessApiDTO {
    /** 工艺ID */
    craftId: string;
    /** 工艺版本工序列表 */
    productCraftProcessDTOList: ProductCraftProcessApiDTO[] | undefined;
}

export class SaveOrUpdateCraftProcessDTO implements ISaveOrUpdateCraftProcessDTO {
    /** 工艺ID */
    craftId!: string;
    /** 工艺版本工序列表 */
    productCraftProcessDTOList!: ProductCraftProcessDTO[] | undefined;

    constructor(data?: ISaveOrUpdateCraftProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            if (data["productCraftProcessDTOList"] && data["productCraftProcessDTOList"].constructor === Array) {
                this.productCraftProcessDTOList = [] as any;
                for (let item of data["productCraftProcessDTOList"])
                    this.productCraftProcessDTOList!.push(ProductCraftProcessDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveOrUpdateCraftProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveOrUpdateCraftProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        if (this.productCraftProcessDTOList && this.productCraftProcessDTOList.constructor === Array) {
            data["productCraftProcessDTOList"] = [];
            for (let item of this.productCraftProcessDTOList)
                data["productCraftProcessDTOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISaveOrUpdateCraftProcessDTO {
    /** 工艺ID */
    craftId: string;
    /** 工艺版本工序列表 */
    productCraftProcessDTOList: ProductCraftProcessDTO[] | undefined;
}

export class SaveRemarkDTO implements ISaveRemarkDTO {
    /** 工艺版本id */
    craftId!: string;
    /** 工艺版本的备注 */
    remark!: string | undefined;

    constructor(data?: ISaveRemarkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.craftId = data["craftId"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): SaveRemarkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRemarkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["craftId"] = this.craftId;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ISaveRemarkDTO {
    /** 工艺版本id */
    craftId: string;
    /** 工艺版本的备注 */
    remark: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}